import { useTranslation } from "react-i18next";
import TabsNavigationBar from "../../components/bar/TabsNavigationBar/TabsNavigationBar";

function LeadReportsNavigationBar(props) {
    const { t } = useTranslation();
    return (
        <TabsNavigationBar
            multipleLocationKey={props.multipleLocationKey}
            pages={[
                {
                    label: t("headers.lead_sources_report"),
                    link: "/marketing-panel/lead-reports/lead_source/",
                },
                {
                    label: t("headers.lead_statuses_report"),
                    link: "/marketing-panel/lead-reports/lead_status/",
                },
                {
                    label: t("headers.lead_status_reasons_report"),
                    link: "/marketing-panel/lead-reports/lead_status_reason/",
                },
                {
                    label: t("headers.lead_channel_efficiency_report"),
                    link: "/marketing-panel/lead-reports/lead_channel_efficiency/",
                },
            ]}
        />
    );
}

export default LeadReportsNavigationBar;
